export function contactMarquee() {
    const marquees = document.querySelectorAll('[data-contact-marquee]');

    if (!marquees.length) return;

    marquees.forEach((marquee) => {
        const groups = marquee.querySelectorAll('[data-contact-marquee-group]');
        const hero = marquee.closest('.contact-hero');
        const details = hero?.querySelectorAll('[data-contact-detail]') || [];
        const gifs = hero?.querySelectorAll('[data-contact-gif]') || [];
        const portrait = hero?.querySelector('[data-contact-portrait]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (groups.length < 2) return;

        const showGif = (key = 'default', bounce = false) => {
            let activeGif = null;

            gifs.forEach((gif) => {
                const isActive = gif.dataset.contactGif === key;

                gsap.killTweensOf(gif);
                gsap.set(gif, { clearProps: 'transform' });
                gif.classList.toggle('is-active', isActive);

                if (isActive) {
                    activeGif = gif;
                }
            });

            if (portrait) {
                gsap.killTweensOf(portrait);
                gsap.set(portrait, { y: 0, scale: 1 });
            }

            if (!bounce || reduceMotion || !activeGif || !portrait) return;

            gsap.timeline()
                .fromTo(portrait, {
                    y: 30,
                    scale: 0.88,
                }, {
                    y: -40,
                    scale: 1.1,
                    duration: 0.28,
                    ease: 'power3.out',
                })
                .to(portrait, {
                    y: 0,
                    scale: 1,
                    duration: 0.75,
                    ease: 'elastic.out(1.15, 0.35)',
                });
        };

        details.forEach((detail) => {
            const key = detail.dataset.contactDetail;

            detail.addEventListener('pointerenter', () => showGif(key, true));
            detail.addEventListener('pointerleave', () => showGif());
            detail.addEventListener('focusin', () => showGif(key, true));
            detail.addEventListener('focusout', () => showGif());
        });

        const media = gsap.matchMedia();

        media.add('(prefers-reduced-motion: no-preference)', () => {
            const tween = gsap.to(groups, {
                xPercent: -100,
                duration: 24,
                ease: 'none',
                repeat: -1,
            });

            return () => tween.revert();
        });
    });
}
